<ion-card>
  <ion-card-header *ngIf="!hideHeader()">
    <ion-card-title>{{ "crowd_login_form_title" | translate }}</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <ion-input
        label="{{ 'crowd_login_email_label' | translate }}"
        labelPlacement="stacked"
        fill="outline"
        email
        required
        maxlength="128"
        placeholder="{{ 'crowd_login_email_placeholder' | translate }}"
        formControlName="email"
        name="email"
        mode="md"
      />

      <ion-input
        label="{{ 'crowd_login_password_label' | translate }}"
        labelPlacement="stacked"
        fill="outline"
        type="password"
        maxlength="128"
        placeholder="{{ 'crowd_login_password_placeholder' | translate }}"
        formControlName="password"
        mode="md"
        password
      >
        <ion-input-password-toggle slot="end"></ion-input-password-toggle>
      </ion-input>

      <ion-text color="danger" *ngIf="validationMessage()">
        {{ validationMessage() | translate }}
      </ion-text>

      <ion-text>
        <a [routerLink]="'/forgot-password' | localePath" (click)="onForgotPasswordClicked()">
          {{ "crowd_login_forgot_password" | translate }}
        </a>
      </ion-text>

      <ion-button class="login-button" expand="block" type="submit">
        {{ "crowd_login_login_action" | translate }}
      </ion-button>
    </form>
  </ion-card-content>
</ion-card>
<ion-text class="ion-text-center">
  <p>
    {{ "crowd_login_no_account" | translate }}
    <a [routerLink]="'/registration' | localePath" (click)="signupClickedEvent.emit()">
      {{ "crowd_login_sign_up" | translate }}
    </a>
  </p>
</ion-text>
